import { render, staticRenderFns } from "./stuPaperCertApply.vue?vue&type=template&id=4f1f4a7a"
import script from "./stuPaperCertApply.vue?vue&type=script&lang=js"
export * from "./stuPaperCertApply.vue?vue&type=script&lang=js"
import style0 from "./stuPaperCertApply.vue?vue&type=style&index=0&id=4f1f4a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports